/* global React, Button, Card, Segmented, EmptyState, DataList, t, fmt,
   PjActivityModal, PjProjectModal, PjDot, pjProducts, pjBillingLabel, pjDateFull */
// Project settings reuse the same create/edit dialogs as the time-entry flows.
function PjInnstillingerTab({ model, searchTarget = null }) {
  const targetActivity = searchTarget?.activityId ? model.activities.find((entry) => entry.id === searchTarget.activityId) || null : null;
  const targetProject = !targetActivity && searchTarget?.projectId ? model.projects.find((entry) => entry.id === searchTarget.projectId) || null : null;
  const [sub, setSub] = useState(targetProject ? 'proj' : 'akt');
  const [activity, setActivity] = useState(targetActivity);
  const [project, setProject] = useState(targetProject);
  useEffect(() => {
    const nextActivity = searchTarget?.activityId ? model.activities.find((entry) => entry.id === searchTarget.activityId) || null : null;
    const nextProject = !nextActivity && searchTarget?.projectId ? model.projects.find((entry) => entry.id === searchTarget.projectId) || null : null;
    if (nextActivity) { setSub('akt'); setActivity(nextActivity); setProject(null); }
    else if (nextProject) { setSub('proj'); setProject(nextProject); setActivity(null); }
  }, [searchTarget?.activityId, searchTarget?.projectId, model.activities, model.projects]);
  return <div>
    <h2 className="t-h1" style={{ marginBottom: 18 }}>{t('pj.settings.title', 'Innstillinger for timeføring')}</h2>
    <Segmented value={sub} onChange={setSub} options={[
      { value: 'akt', label: t('pj.settings.activities', 'Aktiviteter') },
      { value: 'proj', label: t('pj.settings.projects', 'Prosjekter') },
    ]} />
    {sub === 'akt' && <Card style={{ marginTop: 18 }} pad={false}>
      <div className="row between" style={{ padding: 16 }}>
        <b className="t-h2">{t('pj.settings.activities', 'Aktiviteter')}</b>
        <Button icon="plus" disabled={!model.projects.length} onClick={() => setActivity({})} data-help={t('helpTopics.activity.body')} data-help-title={t('helpTopics.activity.title')}>{t('pj.activity.newTitle', 'Ny aktivitet')}</Button>
      </div>
      {model.activities.length === 0
        ? <EmptyState noVisual title={t('pj.settings.noActivitiesTitle', 'Ingen aktiviteter ennå')}
          text={model.projects.length
            ? t('pj.settings.noActivitiesText', 'Aktiviteten bestemmer timepris og hvilket produkt timene faktureres som.')
            : t('pj.settings.noProjectsFirst', 'Opprett et prosjekt først.')} />
        : <DataList tableClass="pj-tbl pj-tbl-cards" rows={model.activities} rowKey={(entry) => entry.id} paginate={false}
          onRowClick={(entry) => setActivity(entry)} columns={[
            { header: t('pj.field.name', 'Navn'), render: (entry) => entry.name },
            { header: t('pj.field.project', 'Prosjekt'),
              sort: (entry) => model.projectsById.get(entry.projectId)?.name || '',
              render: (entry) => {
                const owner = model.projectsById.get(entry.projectId);
                return owner ? <span className="row gap-8"><PjDot color={owner.color} />{owner.name}</span> : null;
              } },
            { header: t('pj.field.product', 'Produkt'), cellClass: 't-sm muted',
              render: (entry) => pjProducts().find((item) => item.id === entry.productId)?.name || '—' },
            { header: t('pj.field.rate', 'Timepris'), headerRight: true, cellClass: 'num',
              sort: (entry) => Number(entry.unitPrice) || 0,
              render: (entry) => (entry.unitPrice ? fmt(entry.unitPrice) : '—') },
            { header: t('pj.filter.billing', 'Fakturering'), cellClass: 't-sm muted',
              render: (entry) => pjBillingLabel(entry.billing) },
          ]} />}
    </Card>}
    {sub === 'proj' && <Card style={{ marginTop: 18 }} pad={false}>
      <div className="row between" style={{ padding: 16 }}>
        <b className="t-h2">{t('pj.settings.projects', 'Prosjekter')}</b>
        <Button icon="plus" onClick={() => setProject({})} data-help={t('helpTopics.project.body')} data-help-title={t('helpTopics.project.title')}>{t('pj.project.newShort', 'Nytt prosjekt')}</Button>
      </div>
      {model.projects.length === 0
        ? <EmptyState noVisual title={t('pj.settings.noProjectsTitle', 'Ingen prosjekter ennå')} text={t('pj.settings.noProjectsText', 'Opprett et prosjekt for å begynne å føre timer.')} />
        : <DataList tableClass="pj-tbl pj-tbl-cards pj-tbl-cards-name2" rows={model.projects} rowKey={(entry) => entry.id} paginate={false}
          onRowClick={(entry) => setProject(entry)} columns={[
            { header: t('pj.field.number', 'Nummer'), sort: (entry) => entry.projectNumber,
              render: (entry) => <span className="row gap-8"><PjDot color={entry.color} />{entry.projectNumber}</span> },
            { header: t('pj.field.name', 'Navn'), render: (entry) => entry.name },
            { header: t('pj.field.customer', 'Kunde'), cellClass: 't-sm muted', render: (entry) => entry.customerName || '—' },
            { header: t('pj.filter.period', 'Tidsrom'), cellClass: 't-sm muted', sort: (entry) => entry.startDate || '',
              render: (entry) => `${pjDateFull(entry.startDate)}${entry.endDate ? ` – ${pjDateFull(entry.endDate)}` : ''}` },
            { header: t('pj.field.status', 'Status'), cellClass: 't-sm muted',
              render: (entry) => (entry.status === 'closed' ? t('pj.project.closed', 'Avsluttet') : t('common.active')) },
          ]} />}
    </Card>}
    {activity && <PjActivityModal open activity={activity} model={model} onClose={() => setActivity(null)} />}
    {project && <PjProjectModal open project={project} model={model} onClose={() => setProject(null)} />}
  </div>;
}

Object.assign(window, { PjInnstillingerTab });
window.dispatchEvent?.(new CustomEvent('plumme-page-registered', { detail: { pages: ['PjInnstillingerTab'] } }));
